




















































import { defineComponent, PropType } from '@vue/composition-api';
import { AnyLearningItem } from '../Model';
import AccreditedBadge from './AccreditedBadge.vue';
import CertificateBadge from './CertificateBadge.vue';
import CompletionCreditsBadge from './CompletionCreditsBadge.vue';
import TotalCreditsBadge from './TotalCreditsBadge.vue';

export default defineComponent({
	components: {
		AccreditedBadge,
		TotalCreditsBadge,
		CertificateBadge,
		CompletionCreditsBadge,
	},
	props: {
		isReduced: Boolean,
		isAdminView: Boolean,
		learningItem: {
			type: Object as PropType<AnyLearningItem>,
			required: true,
		},
	},
	setup() {
		return {};
	},
});
